module.exports = __webpack_public_path__ + "static/media/TeacherContent2.895632d5.svg";